var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"enter-to-class":"animated rubberBand","leave-to-class":"animated fadeOut"}},[(_vm.errors_form.has(_vm.attribute_name))?_c('div',{staticClass:"error-container"},[_c('span',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.errors_form.first(_vm.attribute_name)))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }